import React from 'react';
import classNames from 'classnames';
import { FaTimes as IconClose } from 'react-icons/fa';
import { noop } from 'lodash';

// This file will cause issues moving forward with Styled Components

// This needs to be refactored to allow for additions like RG.

/**
 *
 * @deprecated this is the old base modal component still based on tailwind css, use ReusableModal or ReusableModalPlain instead
 *
 */

const Modal: React.FC<Props> = ({
	children,
	onClose = noop,
	hideClose = false,
	containerClassName,
	bg,
	wrapperClassName,
	showRG,
}) => {
	const handleKeyDown = React.useCallback(
		(e) => {
			if (e.key === 'Escape') {
				onClose();
			}
		},
		[onClose]
	);

	React.useEffect(() => {
		window.addEventListener('keydown', handleKeyDown);

		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [handleKeyDown]);

	React.useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, []);

	return (
		<>
			<div className="_cursor-default _fixed _inset-0 _z-50 _bg-black _opacity-50" onClick={onClose} />
			<div className={classNames('_fixed _z-50 _inset-0')}>
				<div
					style={{ maxHeight: '90%' }}
					className={classNames(
						'_flex _flex-col _py-2 _text-gray-700 _rounded-lg _mt-12 _overflow-hidden',
						{
							'_bg-white _mx-2': bg,
						},
						wrapperClassName
					)}
					role="dialog"
					aria-modal="true"
				>
					{!hideClose && (
						<div className="_flex _justify-end _items-center _mb-2 _px-2">
							<button onClick={onClose}>
								<IconClose className="_w-6 _h-6 _text-gray-700" />
							</button>
						</div>
					)}
					<div className={classNames('_overflow-auto _px-2', containerClassName)}>{children}</div>
				</div>
			</div>
		</>
	);
};

export default Modal;

export const ModalClose: React.FC<{ onClose: () => void }> = ({ onClose }) => (
	<div className="_flex _justify-end _items-center _mb-2 _px-2">
		<button onClick={onClose}>
			<IconClose className="_w-6 _h-6 _text-gray-700" />
		</button>
	</div>
);

interface Props {
	bg?: boolean;
	containerClassName?: string;
	hideClose?: boolean;
	onClose: () => void;
	wrapperClassName?: string;
	showRG?: boolean;
}
